import { ucFirst } from "../format";
import { getSymbol } from "./transactionFormatter";

export const getEthMainInfo = (transaction) => {
  console.log(transaction, "transaction");
  // Destructure details along with other needed fields
  const {
    network,
    hash,
    block,
    details,
    // tx_type
  } = transaction;
  const tokenTransfer = details?.value || details?.token_transfer;

  // Determine if this is a token transfer or native TRX transfer
  let coinLabel = `${ucFirst(network)} • ${getSymbol(network)}`;
  let amountData = null;

  if (tokenTransfer && tokenTransfer.amount) {
    // If it's a token transfer, use the token name for Coin
    coinLabel = `${tokenTransfer.symbol || "Token"}`;

    const amountValue = tokenTransfer.amount;
    const symbol = tokenTransfer.symbol || "";
    // Only add usdString if usd_value exists and is not "0.00"
    const usdString =
      tokenTransfer.usd_value && tokenTransfer.usd_value !== "0.00"
        ? `$\u202F${tokenTransfer.usd_value}`
        : "";
    amountData = {
      amount: `${amountValue} ${symbol.toUpperCase()}`,
      usd_value: `${usdString}`.trim(),
    };
  }

  const mainInfoDetails = [
    {
      id: 1,
      label: "Coin",
      value: coinLabel,
    },
    {
      id: 2,
      label: "Time",
      value: block?.timestamp,
    },
    {
      id: 3,
      label: "Hash",
      value: hash,
      underline: false,
    },
  ];
  console.log(amountData, "amountData");

  return {
    icon: network,
    title: `${ucFirst(network)} transaction`,
    subtitle: "",
    details: mainInfoDetails, // Use the updated details array
    copyValue: hash,
    amountData,
  };
};

export const getEthTableData = (transaction) => {
  console.log("transaction", transaction);
  return [];
};
